import { transactionAxios } from './schedulingApis';

export interface LookAheadConfig {
  dayCount: number | null;
  weekCount: number | null;
  monthCount: number | null;
  maxDaysFromToday: number | null;
}

function positiveCount(value: unknown): number | null {
  if (value == null || value === '') return null;
  const n = typeof value === 'number' ? value : Number(value);
  if (!Number.isFinite(n) || n <= 0) return null;
  return Math.floor(n);
}

function unwrapLookAheadConfig(body: unknown): LookAheadConfig {
  if (!body || typeof body !== 'object') {
    throw new Error('Look-ahead config response was empty.');
  }
  const record = body as { data?: unknown; message?: string };
  const payload = record.data;
  if (!payload || typeof payload !== 'object') {
    const message = typeof record.message === 'string' ? record.message : 'Look-ahead config response did not include data.';
    throw new Error(message);
  }
  const data = payload as Record<string, unknown>;
  return {
    dayCount: positiveCount(data.dayCount),
    weekCount: positiveCount(data.weekCount),
    monthCount: positiveCount(data.monthCount),
    maxDaysFromToday: positiveCount(data.maxDaysFromToday),
  };
}

/** GET /dpr/apis/planning/look-ahead/config. Counts drive the Look-ahead Period window. */
export async function fetchLookAheadConfig(projectId: string): Promise<LookAheadConfig> {
  const query = new URLSearchParams({ projectId });
  try {
    const res = await transactionAxios.get(`dpr/apis/planning/look-ahead/config?${query.toString()}`);
    return unwrapLookAheadConfig(res.data);
  } catch (err) {
    console.error(`Error response: ${err}`);
    throw err;
  }
}
